import Alert from '@jbhi-fi/lanyard-ui/components/Alert/Alert';
import alertType from '@jbhi-fi/lanyard-ui/components/Alert/types/alert.type';
import React from 'react';
import { styles } from './ProductMessage.css';
import { ProductMessage as ProductMessageType } from '../../../PdpProductProvider/types';

export type ProductMessageProps = {
  message: ProductMessageType;
  isAllowedImage?: boolean;
};

const MESSAGE_ALERT_MAP = {
  Important: 'warning',
  Warning: 'warning',
  General: 'info',
  Critical: 'error',
};

export const ProductMessage = ({ message, isAllowedImage = true }: ProductMessageProps) => {
  const { title, content, imageUrl, type: messageType } = message;

  const alertType = MESSAGE_ALERT_MAP[messageType as keyof typeof MESSAGE_ALERT_MAP];

  return (
    <div className={styles.container}>
      {isAllowedImage && imageUrl && content ? (
        <div className={styles.contentContainer}>
          <img className={styles.image} src={imageUrl} alt={title} />
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      ) : (
        <Alert heading={title} type={(alertType as alertType) || 'warning'} showIcon>
          <div className={styles.contentContainer}>
            {content ? <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} /> : null}
          </div>
        </Alert>
      )}
    </div>
  );
};
